import { get } from 'api';

export const getOwnersList = () =>
  get({
    url: '/owners',
  });
